// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__1s32I","regular":"Small_regular__2hmOz","semibold":"Small_semibold__3F-wT","bold":"Small_bold__J7tem"};